import React, { useEffect } from 'react';
import Section from '@components/Section';
import styles from './Highlights.module.scss';
import { ID } from '@app/types';
import { useDispatch, useSelector } from 'react-redux';
import { fetchHighlights } from '@actions/highlights';
import ActivityListItem from '@views/Activity/ActivityListItem';
import { selectHighlights } from '@reducers/data/highlights';
import Content from './HighlightItem/Content';
import Subheader from './HighlightItem/Subheader';

interface HighlightsProps {
  contactID: ID;
}

export function HighlightsList({ highlights }) {
  return (
    highlights.length > 0 && (
      <Section>
        <Section.Title underline>Highlights</Section.Title>
        {highlights.map((item, i) => (
          <div key={i} className={styles.item}>
            <ActivityListItem
              item={item}
              selected={false}
              noContactActions
              noDismissal
              onlyRelativeDate
            />
          </div>
        ))}
      </Section>
    )
  );
}

export function SharedContactHighlightsList({ highlights }) {
  return (
    highlights.length > 0 && (
      <Section>
        <Section.Title underline>Highlights</Section.Title>
        {highlights.map((item, i) => (
          <div key={i} className={styles.sharedContactItem}>
            <Content item={item} />
            <Subheader item={item} />
          </div>
        ))}
      </Section>
    )
  );
}

export default function Highlights({ contactID }: HighlightsProps) {
  const dispatch = useDispatch();
  const highlights = useSelector(selectHighlights(contactID));

  useEffect(() => {
    dispatch(fetchHighlights(contactID));
  }, []);

  return <HighlightsList highlights={highlights} />;
}
